export default {"src":"/_next/static/media/alwaysGeekyGames-dark.54787c87.svg","height":235,"width":463,"blurWidth":0,"blurHeight":0};